import { cn } from '@veraclins-dev/utils';

/**
 * Gives a disabled tooltip trigger its pointer events back, so hovering it
 * opens the tooltip. It must stay the exact inverse of the `disabled:` and
 * `data-[disabled=true]:` pointer rules in `BUTTON_DEFAULT_CLASSES` and
 * `LINK_DEFAULT_CLASSES`, which carry the same pair. `ComposedTooltip` takes
 * any trigger, so both are in reach.
 */
export const DISABLED_TRIGGER_POINTER_CLASSES =
  'disabled:pointer-events-auto data-[disabled=true]:pointer-events-auto';

/**
 * The trigger's class list with `DISABLED_TRIGGER_POINTER_CLASSES` added when
 * it is disabled. Used by `ComposedTooltip` and `Button`, so both give a disabled trigger
 * the same classes.
 */
export function tooltipTriggerClassName({
  className,
  disabled,
}: {
  className?: string;
  disabled?: boolean;
}) {
  return disabled ? cn(className, DISABLED_TRIGGER_POINTER_CLASSES) : className;
}
